import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const PortfolioGrid: React.FC = () => {
  const projects = [
    {
      id: 1,
      slug: 'sustain-documentary-series',
      title: 'Sustain Documentary Series',
      date: '21 April 2025',
      category: 'documentary',
      image: '/portfilio/sustain-documentary-series/video-production-scaled.jpg',
      description: 'Documentary series production.'
    },
    {
      id: 2,
      slug: 'branding-crediconnect',
      title: 'Branding – Crediconnect',
      date: '21 April 2025',
      category: 'branding',
      image: '/portfilio/Branding%20-%20Crediconnect/Branding-Crediconnect.jpg',
      description: 'Brand identity development and design for Crediconnect.'
    },
    {
      id: 3,
      slug: 'events-coverage-fote',
      title: 'Events Coverage – FOTE',
      date: '21 April 2025',
      category: 'events',
      image: '/portfilio/Events%20Coverage%20-%20FOTE/Events-Coverage-FOTE-1.jpg',
      description: 'Voices for Trees and annual walkathon coverage.'
    },
    {
      id: 4,
      slug: 'project-documentation-ilo',
      title: 'Project Documentation – ILO',
      date: '21 April 2025',
      category: 'documentary',
      image: '/portfilio/Project%20Documentation%20%E2%80%93%20ILO/Perpetua-Komoni-farmer.-Chisumbanje-Chipinge.-ZIMBABWE.-Sept-2023.-©Shaun-Chitsiga-ILO-2-scaled.jpg',
      description: 'Spotlight Initiative — project documentation for ILO.'
    },
    {
      id: 5,
      slug: 'human-rights-ngo-forum',
      title: 'Human Rights NGO Forum',
      date: '21 April 2025',
      category: 'documentary',
      image: '/extraimages/Human%20Rights%20NGO%20Forum.jpg.jpeg',
      description: 'Unforgotten Echoes (2023), Justice Delayed Is Justice Denied (2021).'
    },
    {
      id: 6,
      slug: 'fote-walkathon',
      title: 'Annual Tree Planting Walkathon – FOTE',
      date: '21 April 2025',
      category: 'events',
      image: '/extraimages/Annual%20Tree%20Planting%20Walkathon%20%E2%80%93%20FOTE.JPG.jpeg',
      description: 'Documentary coverage of the annual walkathon since 2015.'
    },
    {
      id: 7,
      slug: 'ilo-sedway',
      title: 'ILO SEDWAY Project',
      date: '21 April 2025',
      category: 'documentary',
      image: '/extraimages/ILO%20SEDWAY%20project.JPG.jpeg',
      description: 'Sustainable Enterprise Development for Women and Youth.'
    },
    {
      id: 8,
      slug: 'environment-africa-sustainable-energy',
      title: 'Upscaling Sustainable Energy – Environment Africa',
      date: '21 April 2025',
      category: 'documentary',
      image: '/extraimages/Upscaling%20Sustainable%20Energy%20%E2%80%93%20Environment%20Africa.JPG.jpeg',
      description: 'UNDP GEF-6 biodiversity conservation — documentary and photography.'
    }
  ];

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => {
            const cardContent = (
              <div
                className="relative min-h-[320px] sm:min-h-[380px] rounded-xl overflow-hidden bg-cover bg-center transition-transform duration-300 group-hover:scale-105"
                style={project.image ? { backgroundImage: `url(${project.image})` } : { backgroundColor: '#171717' }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                <div className="absolute inset-0 flex flex-col justify-end p-6">
                  <p className="text-sm text-bizani-orange font-body mb-1">
                    {project.date}
                  </p>
                  <h3 className="text-xl font-headline font-bold text-white mb-2">
                    {project.title}
                  </h3>
                  <p className="text-gray-300 font-body text-sm line-clamp-2">
                    {project.description}
                  </p>
                </div>
              </div>
            );
            return (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
              >
                {project.slug ? (
                  <Link to={`/work/${project.slug}`} className="block" aria-label={project.title}>
                    {cardContent}
                  </Link>
                ) : (
                  cardContent
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PortfolioGrid;
